import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { INVENTORY_FUEL_CATEGORY } from "../../utils/Utils";
import ExchangeInventory from "./ExchangeInventory";

const Inventory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [timeNow, setTimeNow] = useState();
  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])

  const colTable = [
    {
      Header: "Loại",
      accessor: (item) => INVENTORY_FUEL_CATEGORY[item.category],
    },
    {
      Header: "Tổng lượng nhiên liệu(lít)",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.quantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Lượng nhiên liệu còn lại(lít)",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lessQuantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];


  // Changing state value when searching name
  useEffect(() => {
    setLoading(true);
    setData([]);
    const params = {
    }
    GET(`inventory/list`, params, true)
      .then(({ data }) => {
        setData([...data.rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow]);

  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])



  return (
    <React.Fragment>
      <Head title="Quản lý tổng kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Kho nhiên liệu</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <ExchangeInventory resetData={() => {
                        setTimeNow(moment().valueOf());
                      }} />
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <Row className="my-3">
                  {
                    warehouseOptions.map(e => (
                      <Col md={6} className={'py-2'}>
                        <h5>{e.label}</h5>
                        <Table
                          loading={loading}
                          columns={colTable}
                          data={data?.filter(d => d.warehouseId === e.value)}
                          notShowPagi={true}
                        ></Table>
                      </Col>
                    ))
                  }

                </Row>
              </div>
            </div>
          </div>
        </Block>


      </Content>
    </React.Fragment>
  );
};

export default Inventory;
